import 'url-search-params-polyfill';
import * as arrayPolyfill from '../../polyfill/array.js';
import initModals from "./modal";

export default function initFilter() {
    arrayPolyfill.from();

    const formElement = document.querySelector('[filter-submit-form]');
    const formSearchSubmit = document.querySelector('[filter-search]');
    if (document.contains(formElement)) {
        function sendFormData(formElement, push) {
            const formData = new URLSearchParams(Array.from(new FormData(formElement))).toString();

            const Request = new XMLHttpRequest();
            const url = formElement.action;
            const currentUrl = window.location.href.split('?')[0];

            if (formData) {
                Request.open('GET', `${currentUrl}?${formData}`);
            } else {
                Request.open('GET', `${currentUrl}`);
            }
            Request.send(formData);

            const containerElement = document.querySelector('[data-filterable]');
            containerElement.setAttribute('aria-busy', 'true');

            let called = false;
            Request.onreadystatechange = function (e) {
                const isDone = e.target.readyState === 4;
                if (Request.status === 200 && isDone && Request.response && !called) {
                    const el = document.createElement('html');
                    el.innerHTML = Request.response;

                    const containerContent = el.querySelector('[data-filterable]').innerHTML;
                    containerElement.innerHTML = containerContent;
                    called = true;
                    if (push) {
                        if (formData) {
                            history.pushState({}, '', `${currentUrl}?${formData}`);
                        } else {
                            history.pushState({}, '', `${currentUrl}`);
                        }
                    }
                    containerElement.setAttribute('aria-busy', false);
                    initModals();
                }
            };
        }

        window.addEventListener('DOMContentLoaded', () => {
            formElement.addEventListener('change', (e) => {
                e.stopPropagation();
                e.preventDefault();
                sendFormData(formElement, true);
            }, false);

            formElement.addEventListener('keydown', (e) => {
                if (e.keyCode === 13) {
                    e.stopPropagation();
                    e.preventDefault();
                    sendFormData(formElement, true);
                }
            }, false);

            formSearchSubmit.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                sendFormData(formElement, true);
            }, false);

            window.addEventListener('popstate', (e) => {
                e.stopPropagation();
                e.preventDefault();
                sendFormData(formElement, false);
            }, false);
        });
    }
}
